(() => {
  function init() {
    document.querySelectorAll('sticky-atc').forEach((bar) => {
      if (bar.dataset.variantSyncInitialized) return;
      bar.dataset.variantSyncInitialized = 'true';

      const select = bar.querySelector('select[name="id"]');
      const title = bar.querySelector('.psa__title');
      const image = bar.querySelector('.spc__main-img');
      const price = bar.querySelector('.psa__info [data-sticky-variant-price]');
      if (!select || !title || !image || !price) return;

      const sync = (id) => {
        const template = Array.from(bar.querySelectorAll('template[data-sticky-variant]'))
          .find((item) => item.dataset.stickyVariant === String(id));
        if (!template) return;
        const content = template.content;
        title.textContent = content.querySelector('[data-sticky-variant-title]').textContent.trim();
        title.title = title.textContent;
        image.replaceChildren(content.querySelector('[data-sticky-variant-image]').cloneNode(true));
        price.replaceChildren(...content.querySelector('[data-sticky-variant-price]').cloneNode(true).childNodes);
      };

      select.addEventListener('change', () => {
        const variantId = select.value;
        sync(variantId);

        // Use the main picker's normal change flow so media, prices, stock,
        // purchase inputs and the URL all follow the same selected variant.
        const section = bar.closest('[data-section-id]');
        const pickers = (section || document).querySelectorAll('variant-picker');
        pickers.forEach((picker) => {
          if (picker.productId !== bar.dataset.productId) return;
          const variant = picker.productData?.variants.find((item) => String(item.id) === variantId);
          if (!variant) return;

          let changedInput;
          picker.querySelectorAll('[data-picker-field]').forEach((field, index) => {
            const value = variant.options[index];
            const dropdown = field.querySelector('select');
            if (dropdown) {
              dropdown.value = value;
              changedInput = dropdown;
            } else {
              field.querySelectorAll('input[type="radio"]').forEach((input) => {
                input.checked = input.value === value;
                if (input.checked) changedInput = input;
              });
            }
            field.updateSelectedValue?.();
          });
          // All option fields must be set before emitting a single change;
          // intermediate combinations may resolve to a different variant.
          changedInput?.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      window.MinimogEvents.subscribe(`${bar.dataset.productId}__VARIANT_CHANGE`, (variant) => {
        if (variant) sync(variant.id);
      });
      sync(select.value);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
